export enum IMAGE_STATE {
  PRIMARY = 0,
  SECONDARY,
  DOWNLOAD,
  FILETYPE,
}
